import { render, staticRenderFns } from "./medidetale.vue?vue&type=template&id=10f8c5be&scoped=true"
import script from "./medidetale.vue?vue&type=script&lang=js"
export * from "./medidetale.vue?vue&type=script&lang=js"
import style0 from "./medidetale.vue?vue&type=style&index=0&id=10f8c5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8c5be",
  null
  
)

export default component.exports